import React, {Component}                   from "react";
import {Image, ImageBackground, Text, View} from "react-native";
import {connect}                            from "react-redux";
import Modal                                from "./Modal";
import Button                               from "../Button";
import * as Actions                         from "../../constants/Actions";
import * as Screens                         from "../../constants/Screens";
import styles                               from "../../styles/Styles";

class ModalPhotoConfirm extends Component {
    approve = () => {
        this.props.saveIcon(this.props.photoData);
        this.props.changeScreen();
    }

    render() {
        return (
            <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.showPhotoModal}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialogLarge}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Header Row */}
                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>Confirm Photo</Text>
                                    </View>
                                    <View style={styles.lineHorizontalModal} />

                                    <Image source={{uri: "data:image/png;base64," + this.props.photoData}} style={styles.photoPreview} />

                                    <View style={styles.lineHorizontalModal} />
                                    <View style={styles.modalDetailRow}>
                                        <Button onPress={this.props.dismiss} text="Retake" />
                                        <Button onPress={this.approve} text="Confirm" />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        photoData:      state.photoData,
        showPhotoModal: state.showPhotoModal
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   ()      => { dispatch({type: Actions.CHANGE_SCREEN,     screen:      Screens.SETTINGS_PLAYER}) },
        dismiss:        ()      => { dispatch({type: Actions.SHOW_PHOTO_MODAL,  photoData:   null,                      showPhotoModal: false}) },
        saveIcon:       (data)  => { dispatch({type: Actions.SET_PLAYER_ICON,   icon:        data}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalPhotoConfirm);